import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import BrowserImage from "../../assets/images/isometric-browser-window.svg";
import CodeImage from "../../assets/images/isometric-code-icon.svg";
import type { DocsInterfaceProps } from "../../src/chrome/DocsInterface";
import { DocsInterface } from "../../src/chrome/DocsInterface";
import { APIReferenceCalloutLink } from "../../src/components/APIReferenceCalloutLink";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../src/components/SplashPage";

const GuidesPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Learn how to build web apps with Gadget</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
            fontWeight: 300,
          }}
        >
          Learn the fundamentals of the Gadget framework with our guides. The guides will teach you core Gadget concepts, and show you how
          you can compose them to build full-stack web apps.
        </ParagraphLarge>
        <APIReferenceCalloutLink />
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            color={colors.yellow}
            title="Quickstart"
            body="Get started in Gadget and build a sample application."
            copy="Build an app →"
            href="/guides/getting-started/quickstart"
            featureImage={<img src={CodeImage} width="185px" height="115px" />}
          />
          <SplashCard
            color={colors.electricBlue}
            title="Tutorials"
            body="Learn how to build through a series of interactive tutorials."
            copy="Learn more →"
            href="/guides/tutorials"
            featureImage={<img src={BrowserImage} width="125px" height="175px" />}
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default GuidesPage;
